import React, {useState, useEffect} from 'react';
import api from '../contexts/BaseUrl'
import './Sales.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";
import Loading from '../components/Loading';
import { useCallback } from 'react';


function Sales(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    

    const [addSale, setAddSale ]= useState(0);
    const [editSale,setEditSale] = useState(0);
    const [editSaleDetails, setEditSaleDetails] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);

    const [allSales, setAllSales] = useState([]);
    const [saleId, setSaleId] = useState(0);

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('');

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;
    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    //add new sale variable
    const [selectedDate, setSelectedDate] = useState('');
    const selectedDateObj = selectedDate ? new Date(selectedDate) : null;
    
    
    const [assignedTo, setAssignedTo] = useState('');
    const [salesArea, setSalesArea] = useState('');
    const [smallPieces, setSmallPieces] = useState();
    const [largePieces, setLargePieces] = useState();
    const [totalPrice,setTotalPrice] = useState();
    const [paid, setPaid] = useState();
    const [foodExpense,setFoodExpense] = useState();
    const [marketShort, setMarketShort] = useState();

  
   

  
    var url;

    if(dateFromObj != null && dateToObj != null && searchSalesAssignedTo.length>0){
        url = `sales/get-all-sales?assignedTo=${searchSalesAssignedTo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(dateFromObj != null && dateToObj != null){
        url = `sales/get-all-sales?fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(dateFromObj != null && searchSalesAssignedTo.length>0){
        url = `sales/get-all-sales?assignedTo=${searchSalesAssignedTo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(dateFromObj != null){
        url = `sales/get-all-sales?fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(searchSalesAssignedTo.length>0){
        url = `sales/get-all-sales?assignedTo=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=20`
    }
    else{
        url = `sales/get-all-sales?pageNumber=${pageNumber}&pageSize=20` ;
    }


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllSales = useCallback(async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    const fetchSaleDetails = (e) => {
        setIsEditLoading(true);
        api.get(`sales/get-sale-details?saleId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setSaleId(response.data.saleId);
            setSelectedDate(response.data.saleDate);
            setSalesArea(response.data.saleArea);
            setAssignedTo(response.data.saleAssignedTo);
            setSmallPieces(response.data.saleSmallPieces);
            setLargePieces(response.data.saleLargePieces);
            setTotalPrice(response.data.saleTotalPrice);
            setPaid(response.data.salePaid);
            setFoodExpense(response.data.saleFoodExpense);
            setMarketShort(response.data.saleMarketShort);
            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    useEffect(() => {
       fetchAllSales();
    },[fetchAllSales])


    const closeAddSale = () => {
        setSelectedDate('');
        setSalesArea('');
        setAssignedTo('');
        setSmallPieces();
        setLargePieces();
        setTotalPrice();
        setPaid();
        setFoodExpense();
        setMarketShort();
        setAddSale(0);
    }

    const handleAddSales = async (e) => {
        
        e.preventDefault();
        setIsLoading(true);

        await api.post(`sales/create-sale`,{
            saleDate: selectedDateObj,
            saleAssignedTo: assignedTo,
            saleArea: salesArea,
            saleSmallPieces: smallPieces,
            saleLargePieces: largePieces,
            saleTotalPrice: totalPrice,
            salePaid: paid,
            saleFoodExpense: foodExpense,
            saleMarketShort: marketShort
        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllSales();
            setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setSmallPieces();
            setLargePieces();
            setTotalPrice();
            setPaid();
            setFoodExpense();
            setMarketShort();
            setAddSale();
            setIsError(false);
        }).catch(err =>{
            setIsError(true);
            setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setSmallPieces();
            setLargePieces();
            setTotalPrice();
            setPaid();
            setFoodExpense();
            setMarketShort();
        })
    }

    const showEditSale = (e) => {
        fetchSaleDetails(e);
        setEditSaleDetails(1);
    }

    const closeEditSale = () => {
        setSelectedDate('');
        setSalesArea('');
        setAssignedTo('');
        setSmallPieces();
        setLargePieces();
        setTotalPrice();
        setPaid();
        setFoodExpense();
        setMarketShort();
        setIsEditLoading(false);
        fetchAllSales();
        setEditSaleDetails(0);
    }

    const handleEditSale = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        await api.post(`sales/edit-sale`,{
            saleId: saleId,
            saleAssignedTo: assignedTo,
            saleArea: salesArea,
            saleSmallPieces: smallPieces,
            saleLargePieces: largePieces,
            saleTotalPrice: totalPrice,
            salePaid: paid,
            saleFoodExpense: foodExpense,
            saleMarketShort: marketShort
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setSmallPieces();
            setLargePieces();
            setTotalPrice();
            setPaid();
            setFoodExpense();
            setMarketShort();
            setIsEditLoading(false);
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsError(true);
            //setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setSmallPieces();
            setLargePieces();
            setTotalPrice();
            setPaid();
            setFoodExpense();
            setMarketShort();
        })
    }

    const handleDeleteSale = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        await api.post(`sales/delete-sale`,{
            saleId: saleId,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setSmallPieces();
            setLargePieces();
            setTotalPrice();
            setPaid();
            setFoodExpense();
            setMarketShort();
            setIsDeleteLoading(false);
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setSmallPieces();
            setLargePieces();
            setTotalPrice();
            setPaid();
            setFoodExpense();
            setMarketShort();
        })
    }
 
    return(
        <div className='salesPage'> 
    
           <LeftPanel 
                tabName='sales'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Sales Assigned to or by Sales Area'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>
                        </div>
                       <div>{
                           editSale === 0 ?
                           <button 
                                id='editButton'
                                onClick={() => setEditSale(1)}
                            >Edit Sales</button>
                       :
                            <button 
                                id='editCancelButton'
                                onClick={() => setEditSale(0)}
                            >Cancel Edit</button>
                           }
                           
                            <button 
                                id='addButton'
                                onClick={() => setAddSale(1)}
                            >Add Sales</button>
                       </div>
                        
                    </div>
                    <div id='tableBox'>
                        {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Assigned to</th>
                                    <th>Sales Area</th>
                                    <th>Small Pieces</th>
                                    <th>Large Pieces</th>
                                    <th>Total Price</th>
                                    <th>Paid</th>
                                    <th>Food Exp.</th>
                                    <th>Mrkt Short</th>
                                    {editSale === 1 && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.saleDate.substring(0,item.saleDate.length-9)}</td>
                                        <td>{item.saleAssignedTo}</td>
                                        <td>{item.saleArea}</td>
                                        <td>{item.saleSmallPieces}</td>
                                        <td>{item.saleLargePieces}</td>
                                        <td>{item.saleTotalPrice}</td>
                                        <td>{item.salePaid}</td>
                                        <td>{item.saleFoodExpense}</td>
                                        <td>{item.saleMarketShort}</td>
                                        {editSale ===1 && <td onClick={() => showEditSale(item.saleId)} style={{cursor:'pointer'}}>Edit</td>}
                                        
                                    </tr>
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div>
           {
               addSale === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeAddSale}
                    />
                    <form id='modalContent' onSubmit={handleAddSales}>
                        <div id='modalName'>Add New Sale</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeName'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Assigned to:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Assigned Person Name'
                                    required
                                    onChange={(e) => setAssignedTo(e.target.value)}
                                    value={assignedTo}
                                />
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Sales Area:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Address Here'
                                    required
                                    onChange={(e) => setSalesArea(e.target.value)}
                                    value={salesArea}
                                />
                            </div>
                           
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Small Pieces:</div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Small Product Number'
                                    required
                                    onChange={(e) => setSmallPieces(e.target.value)}
                                    value={smallPieces}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Large Pieces:</div>
                                <input
                                    id='typePhone'
                                    type='number'
                                    placeholder='Large Product Number'
                                    required
                                    onChange={(e) => setLargePieces(e.target.value)}
                                    value={largePieces}
                                />
                            </div>
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Price (Tk): </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Total Price Here'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            <div id='name'>
                                <div id='header'>Paid(Tk) : </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Amount Paid'
                                    required
                                    onChange={(e) => setPaid(e.target.value)}
                                    value={paid}
                                />
                            </div> 
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Food Expense:</div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Food expense amount'
                                    required
                                    onChange={(e) => setFoodExpense(e.target.value)}
                                    value={foodExpense}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Market Short:</div>
                                <input
                                    id='typePhone'
                                    type='number'
                                    placeholder='Market short amount'
                                    required
                                    onChange={(e) => setMarketShort(e.target.value)}
                                    value={marketShort}
                                />
                            </div>
                        </div>
                        {isError && 
                            <div id='errorMsg'>Failed adding new sale! Please try again later.</div>
                        }
                        {isLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Sale</button>
                    }
                       
                    </form>
                </div>
               </>
           }
            {
               editSaleDetails === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    {isEditLoading ? 
                    <Loading /> :
                    
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            top:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditSale}
                    />
                    <form id='modalContent' onSubmit={handleEditSale}>
                        <div id='modalName'>Edit Sale</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <div>{selectedDate.substring(0,selectedDate.length-9)}</div>
                            </div>
                            <div id='name'>
                                <div id='header'>Assigned to:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Assigned Person Name'
                                    required
                                    onChange={(e) => setAssignedTo(e.target.value)}
                                    value={assignedTo}
                                />
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Sales Area:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Address Here'
                                    required
                                    onChange={(e) => setSalesArea(e.target.value)}
                                    value={salesArea}
                                />
                            </div>
                           
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Small Pieces:</div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Small Product Number'
                                    required
                                    onChange={(e) => setSmallPieces(e.target.value)}
                                    value={smallPieces}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Large Pieces:</div>
                                <input
                                    id='typePhone'
                                    type='number'
                                    placeholder='Large Product Number'
                                    required
                                    onChange={(e) => setLargePieces(e.target.value)}
                                    value={largePieces}
                                />
                            </div>
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Price (Tk): </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Total Price Here'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            <div id='name'>
                                <div id='header'>Paid(Tk) : </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Amount Paid'
                                    required
                                    onChange={(e) => setPaid(e.target.value)}
                                    value={paid}
                                />
                            </div> 
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Food Expense:</div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Food expense amount'
                                    required
                                    onChange={(e) => setFoodExpense(e.target.value)}
                                    value={foodExpense}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Market Short:</div>
                                <input
                                    id='typePhone'
                                    type='number'
                                    placeholder='Market short amount'
                                    required
                                    onChange={(e) => setMarketShort(e.target.value)}
                                    value={marketShort}
                                />
                            </div>
                        </div>
                        {isError && 
                            <div id='errorMsg'>Failed updating sale! Please try again later.</div>
                        }
                        {isDeleteError && 
                            <div id='errorMsg'>Failed deleting sale! Please try again later.</div>
                        }
                        {isEditLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Sale</button>
                    }
                    
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeleteSale} >Delete</button>
                    }
                    </div>
                    }
                </div>
               </>
           }
          

        </div>
    )
}

export default Sales;